import styled from 'styled-components';
import ds from 'designsystem';

const Header3 = styled.h3`
    color: ${ds.brand('text')};
    font-size: ${ds.fs('l')};
    font-family: ${ds.get('type.fontFamily.headline')};
    font-weight: ${ds.get('type.fontWeight.bold')};
    line-height: ${ds.get('type.lineHeight.l')};
`;

export default Header3;



// WEBPACK FOOTER //
// ./src/elements/Header3.js